import { useEffect, useMemo, useState } from 'react'
import { Group } from '@common/ui'
import { com } from '@eidu/web'
import FieldSingleSelect from './FieldSingleSelect'
import { valueSelectableFieldsOfEntityType, findValueSelectableFieldByIdOrFirst } from '../../util/EntityTypeExtensions'
import useEntityType from '../../io/useEntityType'
import EntitySelector = com.eidu.entity.selector.EntitySelector
import FieldId = com.eidu.entity.field.FieldId
import EntityTypeId = com.eidu.entity.type.EntityTypeId

type FieldValueEqualsInputProps = {
  entityTypeId: EntityTypeId
  selector: EntitySelector.FieldValueEqualsUserEntityId | undefined
  setSelector: (selector: EntitySelector.FieldValueEqualsUserEntityId) => void
  disabled: boolean
}

const FieldValueEqualsUserFieldValueInput = ({
  entityTypeId,
  selector,
  setSelector,
  disabled,
}: FieldValueEqualsInputProps) => {
  const { entityType: localEntityType } = useEntityType(entityTypeId)

  const [localFieldId, setLocalFieldId] = useState<FieldId | undefined>(selector?.fieldId)

  const field = useMemo(
    () => findValueSelectableFieldByIdOrFirst(localEntityType ?? undefined, localFieldId),
    [localEntityType, localFieldId]
  )
  useEffect(() => {
    if (field) {
      setSelector(new EntitySelector.FieldValueEqualsUserEntityId(field.id))
    }
  }, [localFieldId])

  return (
    localEntityType && (
      <Group gap="md" align="flex-start" wrap="nowrap">
        <FieldSingleSelect
          label="Field"
          options={valueSelectableFieldsOfEntityType(localEntityType)}
          selected={field}
          entityType={localEntityType}
          setSelected={(newField) => setLocalFieldId(newField.id)}
          disabled={disabled}
        />
      </Group>
    )
  )
}

export default FieldValueEqualsUserFieldValueInput
